import { Outlet } from "react-router-dom";
import FrontendHeader from "../components/FrontendHeader";
import FrontendFooter from "../components/FrontendFooter";

// FrontendLayout.jsx
const AuthLayout = () => (
  <>
    <FrontendHeader />
    <main>
      <Outlet /> {/* Nested routes render here */}
    </main>
    <FrontendFooter />
  </>
);

export default AuthLayout;
